export default __webpack_public_path__ + "static/media/icon-about-m.2b86237a.svg";